/* @flow */
import axios from 'axios'
import {NEW_NOTIFICATION, REPLACE_NOTIFICATION} from './notifications'

// Commits
export const SET_SYSTEM_THRESHOLDS = 'SET_SYSTEM_THRESHOLDS'

// Dispatches 
export const FETCH_SYSTEM_THRESHOLDS = 'FETCH_SYSTEM_THRESHOLDS'
export const UPDATE_SYSTEM_THRESHOLDS = 'UPDATE_SYSTEM_THRESHOLDS'

export default {
  state: {
    join_failure_threshold: '',
    join_record_threshold: '',
    join_expiration_threshold: '',
    packet_record_threshold: '',
    packet_expiration_threshold: '',
    statistics_record_threshold: '',
    statistics_expiration_threshold: '',
    gw_statistics_record_threshold: '',
    gw_statistics_expiration_threshold: '',
    scan_run_record_threshold: '',
    scan_run_expiration_threshold: '',
    scan_result_record_threshold: '',
    scan_result_expiration_threshold : ''
  },
  getters: {
    getJoinFailureThreshold: state => state.join_failure_threshold,
    getJoinRecordThreshold: state => state.join_record_threshold,
    getJoinExpirationThreshold: state => state.join_expiration_threshold,
    getPacketRecordThreshold: state => state.packet_record_threshold,
    getPacketExpirationThreshold: state => state.packet_expiration_threshold,
    getStatisticsRecordThreshold: state => state.statistics_record_threshold,
    getStatisticsExpirationThreshold: state => state.statistics_expiration_threshold,
    getGwStatisticsRecordThreshold: state => state.gw_statistics_record_threshold,
    getGwStatisticsExpirationThreshold: state => state.gw_statistics_expiration_threshold,
    getScanRunRecordThreshold: state => state.scan_run_record_threshold,
    getScanRunExpirationThreshold: state => state.scan_run_expiration_threshold,
    getScanResultRecordThreshold: state => state.scan_result_record_threshold,
    getScanResultExpirationThreshold: state => state.scan_result_expiration_threshold
  },
  mutations: {
    [SET_SYSTEM_THRESHOLDS](state, entity) {
      state.join_failure_threshold = entity.join_failure_threshold
      state.join_record_threshold = entity.join_record_threshold
      state.join_expiration_threshold = entity.join_expiration_threshold
      state.packet_record_threshold = entity.packet_record_threshold
      state.packet_expiration_threshold = entity.packet_expiration_threshold
      state.statistics_record_threshold = entity.statistics_record_threshold
      state.statistics_expiration_threshold = entity.gw_statistics_expiration_threshold
      state.gw_statistics_record_threshold = entity.gw_statistics_record_threshold
      state.gw_statistics_expiration_threshold = entity.statistics_expiration_threshold
      state.scan_run_record_threshold = entity.scan_run_record_threshold
      state.scan_run_expiration_threshold = entity.scan_run_expiration_threshold
      state.scan_result_record_threshold = entity.scan_result_record_threshold
      state.scan_result_expiration_threshold = entity.scan_result_expiration_threshold
    },
  },
  actions: {
    [FETCH_SYSTEM_THRESHOLDS]: async function({commit, dispatch}) {
      try {
        const {data} = await axios.get(`/system_thresholds/`)
        commit(SET_SYSTEM_THRESHOLDS, data.attributes)
        return {success: true}
      } catch (err) {
        if (err.response) {
          const status = err.response.status
          if (status !== 404) {
            dispatch(NEW_NOTIFICATION, {
              text: 'Failed to load system thresholds ',
              detail: err.message,
              color: 'error',
            })
          }
        }
        else {
          dispatch(NEW_NOTIFICATION, {
            text: 'Invalid response to load system thresholds ',
            detail: err.message ? err.message : 'no message returned',
            color: 'error',
          })
        }
        return {success: false, status}
      }
    },
    [UPDATE_SYSTEM_THRESHOLDS]: async function({commit, dispatch}, payload) {
      const notificationId = await dispatch(NEW_NOTIFICATION, {
        text: 'Saving...',
        color: 'secondary',
        undoable: true,
      })

      try {
        const {data} = await axios.put(`/system_thresholds/`, {
          data: {
            type: 'system_thresholds',
            attributes: payload,
          },
        })
        commit(SET_SYSTEM_THRESHOLDS, payload)
        commit(REPLACE_NOTIFICATION, {
          id: notificationId,
          text: 'Saved!',
          color: 'success',
          undoable: true,
        })
        return true
      } catch (err) {
        commit(REPLACE_NOTIFICATION, {
          id: notificationId,
          text: 'Failed to update system thresholds ',
          detail: err.message,
          color: 'error',
        })
      }
      return false
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/system_thresholds.js